<ion-header>
  <ion-toolbar>
    <ion-title>Bestellen</ion-title>
  </ion-toolbar>
  <ion-row
    style="background-color: var(--ion-background-color); font-size: small; font-weight: bold"
  >
    <ion-col size="5">Bezeichnung</ion-col>
    <ion-col size="2">Einh.</ion-col>
    <ion-col size="1" style="text-align: center">Inhalt</ion-col>
    <ion-col size="2" style="text-align: right" *ngIf="preisAnzeigen">Preis</ion-col>
    <ion-col size="2" style="text-align: right" *ngIf="!preisAnzeigen"></ion-col>
    <ion-col size="2">Bestell-Eh.</ion-col>
  </ion-row>
</ion-header>

<ion-content>
  <ion-list style="padding-top: 0">
    <ng-container *ngFor="let artikel of artikelRes.artikel">
      <ion-row *ngIf="artikel.pos.eh > 0 && lieferbar(artikel)">
        <ion-col size="5">{{artikel.bezeichnung}}</ion-col>
        <ion-col size="2">{{artikel.bestelleinheit}}</ion-col>
        <ion-col size="1" style="text-align: center"
          >{{artikel.multiplikator * artikel.vpe}}</ion-col
        >
        <ion-col size="2" style="text-align: right" *ngIf="preisAnzeigen"
          >{{artikel.vkPreis.toFixed(2).replace('.', ',')}} €</ion-col
        >
        <ion-col size="2" style="text-align: right" *ngIf="!preisAnzeigen"></ion-col>
        <ion-col size="2">
          <input
            style="width: 48px; text-align: center; margin-top: 0px; font-weight: bold"
            [style.backgroundColor]="config.inputHintergrundFarbe"
            [style.border]="config.inputBorder"
            appSelectOnClick
            [class.number]="true"
            [class.overMax]="artikel.pos.eh > artikel.maxEh"
            type="number"
            [(ngModel)]="artikel.pos.eh"
            min="0"
            [max]="artikel.maxEh"
            (ngModelChange)="checkMax(artikel); updateWarenkorb(artikel); calcWarenwert();"
          />
        </ion-col>
      </ion-row>
      <ng-container *ngIf="artikel.hatSorten">
        <ng-container *ngFor="let sorte of artikel.sorten">
          <ion-row *ngIf="sorte.pos.eh > 0 && lieferbar(sorte)">
            <ion-col size="5">{{sorte.bezeichnung}}</ion-col>
            <ion-col size="2">{{sorte.bestelleinheit}}</ion-col>
            <ion-col size="1" style="text-align: center"
              >{{sorte.multiplikator * sorte.vpe}}</ion-col
            >
            <ion-col size="2" style="text-align: right" *ngIf="sorte.preisAnzeigen"
              >{{sorte.vkPreis.toFixed(2).replace('.', ',')}} €</ion-col
            >
            <ion-col size="2">
              <input
                style="width: 48px; text-align: center; margin-top: 0px; font-weight: bold"
                [style.backgroundColor]="config.inputHintergrundFarbe"
                [style.border]="config.inputBorder"
                appSelectOnClick
                [class.number]="true"
                [class.overMax]="sorte.pos.eh > sorte.maxEh"
                type="number"
                [(ngModel)]="sorte.pos.eh"
                min="0"
                [max]="sorte.maxEh"
                (ngModelChange)="checkMax(sorte); updateWarenkorb(sorte); calcWarenwert();"
              />
            </ion-col>
          </ion-row>
        </ng-container>
      </ng-container>
    </ng-container>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-item
    class="ion-text-wrap"
    style="background-color: var(--ion-background-color)"
    lines="none"
  >
    <ion-label>
      CC: {{ccs}} Einheiten: {{einheiten}}<br />
      <span style="font-weight: bold" *ngIf="preisAnzeigen"
        >Warenwert: {{warenwert.toFixed(2).replace('.', ',')}} €</span
      >
      <!-- <span style="font-weight: bold;"*ngIf="!preisAnzeigen"></span> Stattdessen eine leere Zeile anzeigen? -->
    </ion-label>
  </ion-item>
  <ion-item style="--background: white">
    <ion-label position="floating">Bemerkung</ion-label>
    <ion-input [(ngModel)]="bemerkung" maxlength="500"></ion-input>
  </ion-item>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button (click)="cancel()" expand="full" color="danger">
          <ion-icon slot="start" name="close"></ion-icon>
          Abbrechen
        </ion-button>
      </ion-col>
      <ion-col>
        <ion-button (click)="ok()" expand="full" [disabled]="einheiten === 0">
          <ion-icon slot="start" name="checkmark"></ion-icon>
          Bestellung absenden
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
